import React from 'react';
import { TextField } from "@material-ui/core";

//Si hay un editor, specific debe ser = false
const OnlyText = React.memo(({title, element, handleChange, data, specific, type, inputProps, placeHolder}) => {
    if (!data) return (<></>)
    return (
        <>
            <TextField
                id={`${element}`}
                label={title}
                value={data[element]}
                onChange={handleChange(element)}
                InputLabelProps={{
                shrink: true
                }}
                margin="normal"
                variant="standard"
                type={`${type ? type : "text"}`}
                required
                inputProps={inputProps ? inputProps : {}}
                placeholder={placeHolder ? placeHolder : ""}
            />
        </>
    )
}, (prevProps, nextProps) => {
    if (!prevProps.data || !nextProps.data) return false;
    if (prevProps?.specific === undefined || prevProps?.specific) return prevProps.data[prevProps.element] === nextProps.data[nextProps.element];
    return prevProps.data === nextProps.data;
});

export default OnlyText;